import './style.scss'
import { useContext, useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import ApiContext from 'src/provider/API/call-service'
import { AbsoluteContainer, AppSpan, Button, CustomContainer, FlexRow, GridContainer, ScreenContainer, ScreenTitle } from "src/style"
import utility from "src/utils/utility"
import helpers from 'src/utils/helpers'
import { SearchInput, ServerSideTable } from 'src/component'
import { customersColumn, customersData } from 'src/utils/tableLayout'
import { Customer, Subsidiary, UserType } from 'src/model'
import {ReactComponent as NoUserIcon} from 'src/assets/svg/no-user-icon.svg'
import { IoMdAdd } from 'react-icons/io'
import { NewCustomerBasicDetails, NewCustomerLocation } from 'src/popup'

const Customers: React.FC<any> = () => {
    const navigate = useNavigate()
    const {API} = useContext(ApiContext)
    const {info: {selectedSubsidiary, userType}, setInfoProperty} = useContext(AppInfoContext)
    const [navPosition, setNavPosition] = useState(0)
    const [customersInfo, setCustomersInfo] = useState<any>(null)
    const [customers, setCustomers] = useState<any[]>([])
    const [mockTableData, setMockTableData] = useState<any[]>([])
    const [subsidiary, setSubsidiary] = useState<Subsidiary>(selectedSubsidiary)
    const [currentUserType, setCurrentUserType] = useState('')
    const [view, setView] = useState('')

    useEffect(() => {
        if (selectedSubsidiary?.id) setSubsidiary(selectedSubsidiary)
        if (userType) setCurrentUserType(userType)
    }, [selectedSubsidiary, userType])

    useEffect(() => {
       if (selectedSubsidiary && userType) handleFetchCustomers()
    }, [navPosition, selectedSubsidiary, userType]) 

    async function handleFetchCustomers (pageNumber = 1, pageSize = 10) {
        const response = await API.getCustomers({
            page: pageNumber, size: pageSize,
            verificationStatus: navPosition != 0 ? (navPosition === 14.5 ? 'VERIFIED' : 'PENDING') : null,
            organizationId: (selectedSubsidiary?.id && userType === (UserType.COMPANY || UserType.ADMIN)) ? selectedSubsidiary?.id : null
        })
        if (response) {
            setCustomersInfo(response)
            setCustomers(response.data)
            setMockTableData(response.data)
        }
    }

    function handleDataSearching (e: React.ChangeEvent<HTMLInputElement>) {
        const filteredData = helpers.searchTableData(customers, e.target.value)
        setMockTableData(filteredData)
    }

    async function handleRowClick (data: Customer) {
        await setInfoProperty('selectedCustomer', data)
        navigate('/dashboard/customers/customer-details')
    }
    
    return (
        <>
            <ScreenContainer padding='2.5'>
                <FlexRow
                    justifyContent="space-between" gap="2.5" 
                    wrap="wrap" bottomMargin='4'
                >
                    <ScreenTitle 
                        color='#333333' 
                        textSize='2.4' 
                        fontWeight='700'
                    >
                        {((currentUserType === UserType.COMPANY || currentUserType === UserType.ADMIN) && subsidiary?.name) ? `${subsidiary?.name} Customers` : 'Customers'}
                    </ScreenTitle>
                    <Button 
                        width='20.5' 
                        hoverBgColor='#ffffff' 
                        hoverColor='#5627FF'
                        borderColor='#5627FF'
                        onClick={() => setView('customer-basic-details')}
                    >
                        <IoMdAdd fontSize='1.9rem' style={{marginRight: '1rem'}} />
                        Add New Customer
                    </Button>
                </FlexRow>
                <FlexRow justifyContent='space-between' wrap='wrap' gap='2.5'>
                    <GridContainer
                        className='scrollable-container toggle-border-bottom'
                        height="3.6" width='51'
                    >
                        <AbsoluteContainer 
                            width={navPosition === 0 ? '11.6' : navPosition === 14.5 ? '15' : '16.5'} 
                            top="0" left={`${navPosition}`}
                        >
                            <CustomContainer 
                                bgColor="#F0ECFF" height="3.6" 
                                borderBottomColor='#5627FF' borderWidth='4.5'
                            />
                        </AbsoluteContainer>
                        <FlexRow
                            alignItems='flex-start'
                            gap='1'
                            style={{zIndex: '2'}}
                        >
                            <GridContainer 
                                width='11.6' rightMargin='1.5' 
                                hoverBgColor={navPosition === 0 ? '' : '#F0ECFF'}
                                onClick={() => setNavPosition(0)}
                                className='toggled-item'
                            >
                                <AppSpan  
                                    cursor="pointer"
                                    fontWeight={navPosition === 0 ? "700" : "400"}
                                    color={navPosition === 0 ? "#181D27" : "#828282"}
                                >
                                    All Customers
                                </AppSpan>
                            </GridContainer>
                            <GridContainer 
                                width='15' rightMargin='1.5'
                                hoverBgColor={navPosition === 14.5 ? '' : '#F0ECFF'}
                                onClick={() => setNavPosition(14.5)}
                                className='toggled-item'
                            >
                                <AppSpan 
                                    cursor="pointer"
                                    fontWeight={navPosition === 14.5 ? "700" : "400"}
                                    color={navPosition === 14.5 ? "#181D27" : "#828282"}
                                >
                                    Verified Customers
                                </AppSpan>
                            </GridContainer>
                            <GridContainer 
                                width='16.5'
                                hoverBgColor={navPosition === 32 ? '' : '#F0ECFF'}
                                onClick={() => setNavPosition(32)}
                                className='toggled-item'
                            >
                                <AppSpan 
                                    cursor="pointer"
                                    fontWeight={navPosition === 32 ? "700" : "400"}
                                    color={navPosition === 32 ? "#181D27" : "#828282"}
                                >
                                    Unverified Customers
                                </AppSpan>
                            </GridContainer>
                        </FlexRow>
                    </GridContainer>

                    { !!mockTableData?.length &&
                        <SearchInput onChange={handleDataSearching} />
                    }
                </FlexRow>

                <CustomContainer topMargin='4'>
                    <ServerSideTable
                        tableColumns={customersColumn}
                        tableData={mockTableData}
                        dataFetchMethod={handleFetchCustomers}
                        totalRows={customersInfo?.totalResults}
                        noDataText='No Customers'
                        noRadius
                        onRowClickMethod={handleRowClick}
                        noDataCustomIcon={ <NoUserIcon className="icon-component" /> }
                    />
                </CustomContainer>
            </ScreenContainer>
            { view === 'customer-basic-details' &&
                <NewCustomerBasicDetails
                    close={() => setView('')} 
                    next={() => setView('customer-location-details')}
                />
            }
            { view === 'customer-location-details' &&
                <NewCustomerLocation 
                    close={() => setView('')} 
                    back={() => setView('customer-basic-details')}
                    fetchCustomers={handleFetchCustomers}
                />
            }
        </>
    )
}

export default utility.routeData('customers', 'Customers', <Customers/>)